import { AppTable } from 'shared/UI/UIKit/Table';
import type { BuildingsTableProps } from './types';
import { useBuildingsTable } from './use-table';

export const BuildingsTable = (props: BuildingsTableProps) => {
  const { onRow } = useBuildingsTable();

  return (
    <AppTable
      dataSource={props.dataSource}
      onRow={onRow}
      columns={props.columns}
      loading={props.loading}
      rowKey={(record) => record.id}
      pagination={props.tableState.pagination}
      sorters={props.tableState.sorters}
      className={props.className}
      onChange={props.onChange}
    />
  );
};
